export default {
      id: "ic_mp_footer-usage",
      viewBox: "0 0 236.46 62.34",
      url: "/" + "images/icons.3.109.2.svg#ic_mp_footer-usage",
      toString: function () {
        return this.url;
      }
    }